import PaymentsAndBilling from './PaymentsAndBilling'

export default PaymentsAndBilling
